import { JournalVehicle } from '../types';
import { CommonApi, CommonApiMethod } from '.';
const route = 'journalVehicle';
const journalVehicle: CommonApiMethod = new CommonApi<JournalVehicle>(
  route,
  'Транспорт по заявки журнала',
);

export default journalVehicle;
